"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  footer: {
    paddingBottom: 8,
    boxSizing: 'border-box',
    '&:empty': {
      paddingTop: 0,
      paddingBottom: 0
    }
  },
  footerRow: {
    position: 'relative',
    width: 304,
    height: 40,
    display: 'flex',
    alignItems: 'center'
  },
  toggleLabel: {
    flex: '0 0 auto',
    width: 272,
    position: 'relative',
    top: -1
  },
  selectLabel: {
    flex: '0 0 auto',
    width: 60,
    position: 'relative',
    top: -1
  },
  divider: {
    marginBottom: 8,
    marginTop: 8
  },
  footerDivider: {
    marginBottom: 8
  },
  selectContainer: {
    width: '100%'
  },
  select: {
    '& input': {
      textAlign: 'right',
      fontWeight: 600,
      fontSize: 'inherit',
      fontFamily: 'inherit',
      color: 'inherit'
    },
    '& > *:first-child': {
      paddingBottom: 0,
      paddingTop: 0
    },
    '& .field': {
      fontWeight: 500,
      borderBottom: 'none',
      padding: '10px 2px 11px 8px',
      alignItems: 'right'
    },
    '& .focus .field': {
      borderColor: `${theme.calendar.timeBorderActiveColor} !important`
    },
    '& .rightIcon': {
      marginLeft: 8,
      '& .fill': {
        fill: theme.calendar.timezoneIconColor
      },
      '& .stroke': {
        stroke: theme.calendar.timezoneIconColor
      }
    }
  },
  medium: {
    width: 304
  },
  small: {
    width: 216,
    '& $footerRow': {
      height: 24,
      width: 216
    },
    '& $toggleLabel': {
      width: 182
    },
    '& $select': {
      '& input': {
        fontSize: 12
      }
    }
  }
});

exports.default = _default;